// 在client/src/components/目录下创建一个新文件ManualCheckButton.js

import React, { useState } from 'react';
import api from '../services/api';

const ManualCheckButton = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleManualCheck = async () => {
    try {
      setIsLoading(true);
      setResult(null);
      
      // 调用手动检查API
      const response = await api.get('/api/cron/check-sites');
      
      // 显示结果
      setResult({
        success: true,
        message: `检查完成，发现${response.data.changes?.length || 0}个变更`
      });
    } catch (error) {
      setResult({
        success: false,
        message: error.response?.data?.message || '检查失败，请稍后再试'
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="manual-check-container">
      <button 
        className="btn btn-primary" 
        onClick={handleManualCheck} 
        disabled={isLoading}
      >
        {isLoading ? '检查中...' : '立即检查网站变更'}
      </button>
      
      {result && (
        <div className={`alert ${result.success ? 'alert-success' : 'alert-danger'} mt-3`}>
          {result.message}
        </div>
      )}
    </div>
  );
};

export default ManualCheckButton;